export var AUTH_UPDATE = { type: "AuthActions_AuthUpdate" };
export var NO_AUTH_ACTION = { type: "AuthActions_LegacyNoAction" };
export var SyncFromV4 = function (auth) {
    if (!auth) {
        return {
            type: AUTH_UPDATE,
            auth: null
        };
    }
    var apps = auth.apps, user = auth.user, sessionId = auth.sessionId, branding = auth.branding, userTenant = auth.userTenant, upsell = auth.upsell, onboarding = auth.onboarding;
    return {
        type: AUTH_UPDATE,
        auth: {
            apps: apps,
            branding: branding,
            featureFlags: {},
            onboarding: onboarding,
            sessionId: sessionId,
            upsell: upsell,
            user: user,
            userTenant: userTenant
        }
    };
};
var NoAction = function () {
    return function (dispatch) {
        dispatch({
            type: NO_AUTH_ACTION
        });
        return Promise.resolve();
    };
};
var updateTenant = function () {
    return function (dispatch, getState) {
        var _a, _b;
        dispatch({
            type: NO_AUTH_ACTION
        });
        return Promise.resolve((_b = (_a = getState()) === null || _a === void 0 ? void 0 : _a.auth) === null || _b === void 0 ? void 0 : _b.userTenant);
    };
};
/** @deprecated: Do not use going forward, use `withAuth` or `useAuth` or auth helper */
export default {
    SyncFromV4: SyncFromV4,
    login: NoAction,
    resume: NoAction,
    ghostLogin: NoAction,
    singleSignOn: NoAction,
    logout: NoAction,
    updateTenant: updateTenant,
    UpdateAuthAction: NoAction,
    updateTenantFromRegionalIdentity: NoAction
};
